module.exports = __webpack_public_path__ + "img/5.dae19efc.png";